import { Context } from '@getaccept/editor-lib-new';
import { computed, defineComponent } from 'vue';
import { SigningHelper } from '@getaccept/lib-shared-new/src/signature/helpers/signing.helper';
import { useInputFieldView } from '../composables/input-field-view.composable';
import InputSetLabel from './InputSetLabel.vue';
import InputSetField from './InputSetField.vue';
export default defineComponent({
    name: 'InputSet',
    components: {
        InputSetField,
        InputSetLabel,
    },
    props: {
        context: { type: String, default: () => Context.Document },
        failedInputUpdates: { type: Array, default: () => [] },
        fields: { type: Array, default: () => [] },
        focusedRequiredId: { type: String, default: '' },
        inputSet: { type: Array, default: () => [] },
        isMobile: { type: Boolean },
        isPdfViewer: { type: Boolean },
        mergeValues: { type: Object, default: () => ({}) },
        recipient: { type: Object, default: () => ({}) },
        recipientInput: { type: Array, required: true },
        sender: { type: Object, default: () => ({}) },
        updatingInputs: { type: Array, default: () => [] },
    },
    emits: ['update-value'],
    setup(props) {
        const { getIsAssignedToCurrentUser } = useInputFieldView(props);
        const hasRecipientSigned = computed(() => { var _a; return SigningHelper.hasRecipientSigned((_a = props.recipient) === null || _a === void 0 ? void 0 : _a.status); });
        const hasFocus = (input) => {
            if (!getIsAssignedToCurrentUser(input)) {
                return false;
            }
            return input.id === props.focusedRequiredId;
        };
        const getIsEditable = (input) => getIsAssignedToCurrentUser(input) &&
            !hasRecipientSigned.value &&
            props.context !== Context.DocumentView &&
            !props.isPdfViewer;
        const getInputStyle = (input) => {
            var _a;
            const width = props.isMobile ? 100 : ((_a = input.inputSettings) === null || _a === void 0 ? void 0 : _a.width) || 100;
            return `width: ${width}%;`;
        };
        return {
            getInputStyle,
            getIsAssignedToCurrentUser,
            getIsEditable,
            hasFocus,
            hasRecipientSigned,
        };
    },
});
